import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0.5, 1),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    marginLeft: theme.spacing(0.5),
    flex: 1,
    fontSize: '0.95rem',
    letterSpacing: '0.01em',
  },
  iconButton: {
    padding: 8,
    color: theme.palette.text.secondary,
  },
}));

const SearchInput = ({ value, onChange, placeholder = 'Search…' }) => {
  const classes = useStyles();

  return (
    <Paper component='div' className={classes.root} elevation={0}>
      <IconButton className={classes.iconButton} aria-hidden tabIndex={-1} disabled size='small'>
        <SearchIcon fontSize='small' />
      </IconButton>
      <InputBase
        className={classes.input}
        placeholder={placeholder}
        value={value}
        inputProps={{ 'aria-label': 'Search jobs', autoComplete: 'off' }}
        onChange={(event) => onChange(event.target.value)}
      />
    </Paper>
  );
};

export default SearchInput;
